if (!customElements.get("a-sale-price")) {
  customElements.define(
    "a-sale-price",
    class ASalePrice extends HTMLElement {
      constructor() {
        super();

        this.bfs = this.querySelectorAll(".sale-price-bar");
        this.regulars = this.querySelectorAll(".regular-price-block");
        this.normals = this.querySelectorAll(".normal-price-block");
      }

      connectedCallback() {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const id = event.data.variant.id.toString();
          this.update(id);
        });
      }

      disconnectedCallback() {
        if (this.unsub) this.unsub();
      }

      update(id) {
        // Hide everything
        this.bfs.forEach((el) => el.classList.add("hidden"));
        this.regulars.forEach((el) => el.classList.add("hidden"));
        this.normals.forEach((el) => el.classList.add("hidden"));

        // BF blocks for this variant
        const bfBar = this.querySelector(`.sale-price-bar[data-variant="${id}"]`);
        const bfReg = this.querySelector(`.regular-price-block[data-variant="${id}"]`);
        const normal = this.querySelector(`.normal-price-block[data-variant="${id}"]`);

        const isBF = bfBar && !bfBar.classList.contains("no-bf");

        if (isBF) {
          bfBar.classList.remove("hidden");
          bfReg.classList.remove("hidden");
        } else {
          normal.classList.remove("hidden");
        }
      }
    }
  );
}